<template>
  <q-page class="flex flex-center">
    <div class="column items-center q-ma-xl">
      <t-logo style="width: 200px; height: 200px" />
      <q-img v-if="data.image" :placeholder-src="placeholderUrl" :src="imageUrl">
        <template #loading>
          <q-spinner color="white" size="2em" />
        </template>
      </q-img>
      <portable-text v-if="data.body" :component="{}" :value="data.body" />
    </div>
  </q-page>
</template>

<script setup>
import { computed } from 'vue'
import { keepPreviousData, useQuery } from '@tanstack/vue-query'
import { storeToRefs } from 'pinia'
// import { useMeta } from "quasar";
import { queryClient } from 'src/boot/vueQuery'
import { queryHome } from 'src/api/sanity/queries/home'
import { useDehydrateQueryClient } from 'src/composables/useDehydrateQueryClient'
import { useHydrateQueryClient } from 'src/composables/useHydrateQueryClient'
import { useQueryErrorHandler } from 'src/composables/useQueryErrorHandler'
import { useUpdateStoreFromQuery } from 'src/composables/useUpdateStoreFromQuery'
import { useHomeStore } from 'src/stores/home'
import { PortableText } from '@portabletext/vue'
import TLogo from 'src/components/logo/TLogo.vue'
import { useResponsiveImageWidth } from 'src/composables/useResponsiveImageWidth'
import { urlFor } from 'src/boot/sanityUrlFor'

const QKEY = 'IndexPage'

defineOptions({
  name: QKEY,
  async preFetch({ store, ssrContext }) {
    const homeStore = useHomeStore(store)
    try {
      await queryClient.prefetchQuery({
        queryKey: [QKEY],
        queryFn: () => queryHome(),
      })
      homeStore.home = queryClient.getQueryData([QKEY])
      useDehydrateQueryClient(ssrContext)
    } catch (e) {
      console.error('Failed to execute preFetch queryPage', e)
    }
  },
})

const responsiveWidth = useResponsiveImageWidth(960)
const homeStore = useHomeStore()
const { home } = storeToRefs(homeStore)

const { data, error, isError } = useQuery({
  queryKey: [QKEY],
  queryFn: () => queryHome(),
  initialData: home?.value,
  placeholderData: keepPreviousData,
})

useQueryErrorHandler(error, isError)
useUpdateStoreFromQuery(data, home)
useHydrateQueryClient()

const imageUrl = computed(() =>
  urlFor(data.value?.image?.asset?.url).width(responsiveWidth.value).url(),
)
const placeholderUrl = computed(() => data.value?.image?.asset?.metadata?.lqip)
</script>
